export default __webpack_public_path__ + "static/media/moot-court-4.f1c1c2cd.webp";